var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:(_vm.cssProps)},[_c('form',{staticClass:"paymentWidgets",attrs:{"action":_vm.formActionUrl,"data-brands":"PAYPAL"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }